import { mdiNoteMultipleOutline } from '@mdi/js'

export default {
  title: 'Bank Question Teacher',
  to: 'bank-teacher',
  icon: mdiNoteMultipleOutline,
  resource: 'BankQuestionTeacher',
  action: 'read',
}
